import { useEffect } from "react";
import L from "leaflet";
import { MapContainer, TileLayer, Polyline, Marker, useMap } from "react-leaflet";
import { CATEGORY } from "@/lib/constants";
import { signIcon } from "@/components/map/SignObjects";
import { StaffMarkers } from "@/components/map/StaffMarkers";

const num = (n, color) => L.divIcon({
  className: "",
  html: `<div class="tac-marker" style="width:22px;height:22px;background:${color};color:${color}"><span style="color:#fff">${n}</span></div>`,
  iconSize: [22, 22], iconAnchor: [11, 11],
});

const Fit = ({ pts }) => {
  const map = useMap();
  useEffect(() => {
    const t = setTimeout(() => {
      map.invalidateSize();
      if (pts.length > 1) map.fitBounds(pts, { padding: [30, 30], maxZoom: 17 });
      else if (pts.length === 1) map.setView(pts[0], 17);
    }, 150);
    return () => clearTimeout(t);
  }, [map, pts]);
  return null;
};

export const SheetMap = ({ unit, route, signs = [], staff = [], ownSigns = [] }) => {
  const posts = unit.segments.filter((s) => s.loc);
  const postPts = posts.map((s) => s.loc);
  const pts = [...postPts, ...signs.filter((g) => ownSigns.includes(g.id)).map((g) => g.coords[0])];
  return (
    <div className="h-[240px] border border-slate-300 rounded overflow-hidden mt-4 relative isolate z-0" data-testid={`sheet-map-${unit.id}`}>
      <MapContainer center={pts[0] || [42.3929, -8.7042]} zoom={16} maxZoom={22} style={{ height: "100%", width: "100%" }}
        zoomControl={false} dragging={false} scrollWheelZoom={false} doubleClickZoom={false} attributionControl={false}>
        <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" maxZoom={22} maxNativeZoom={19} />
        <Fit pts={pts} />
        {route && <Polyline positions={route} pathOptions={{ color: "#0ea5e9", weight: 4, opacity: 0.35 }} />}
        {signs.map((g) => <Marker key={g.id} position={g.coords[0]} icon={signIcon(g, false)} interactive={false} />)}
        <StaffMarkers points={staff} />
        {posts.map((s, i) => <Marker key={i} position={s.loc} icon={num(i + 1, CATEGORY[s.category]?.color || "#334155")} />)}
      </MapContainer>
    </div>
  );
};
